{
  "header": {
    "mainNumber": "Hovednummer",
    "supplierNumber": "Leverandørnummer",
    "area": "Areal",
    "shares": "Andeler"
  },
  "table": {
    "property": "Eiendom",
    "area": "Areal",
    "shares": "Andeler",
    "forestQuality": "Bonitet"
  },
  "documentation": {
    "badges": {
      "exclusiveUsageRights": "Eksklusiv bruksrett",
      "usageRights": "Bruksrett",
      "ownershipWithPartner": "Eierskap deles med partner",
      "sameieRequiresDocumentation": "Sameie som krever dokumentasjon"
    },
    "manageDocumentation": "Administrer dokumentasjon",
    "viewDocuments": "Vis {{count}} dokument(er)",
    "viewUndocumentedVerification": "Verifisert uten dokumentasjon"
  },
  "actions": {
    "archiveProperty": "Arkiver eiendom"
  }
}
